module.exports = __webpack_public_path__ + "static/media/total investment.b8469415.svg";